import {Icon, IconProps} from "atmosfair-ui";
import {theme} from "../../../../styles/theme";
import React, {useEffect} from "react";
import {ICON_MARGIN} from "../utils";
import "./styles.css"
import {Tooltip} from "@mui/material";
import {setJourneyHideLoadBundleInformation} from "../../../../redux/reducer/journey";
import {setTravelComponentsHideLoadBundleInformation} from "../../../../redux/reducer/travel-components";
import {useAppDispatch} from "../../../../redux/reducer/store";
import {WhereToDisplayActivityString} from "../../../../utils/string/common";

export enum WHICH_FOOTNOTE_TYPE {
    date, warning, route, calculation
}

interface StringDisplayFootnoteIconProps {
    isWarning?: boolean
    icon?: IconProps["icon"]
    iconColor?: string,
    whichFootnoteType?: WHICH_FOOTNOTE_TYPE,
    tooltip?: string,
    whereToDisplay?: WhereToDisplayActivityString,
    hideOnClick?: boolean,
    activityId?: string,
}

const StringDisplayFootnoteIcon = ({
                                       isWarning,
                                       icon,
                                       iconColor,
                                       whichFootnoteType,
                                       tooltip,
                                       whereToDisplay,
                                       hideOnClick,
                                       activityId,
                                   }: StringDisplayFootnoteIconProps) => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (hideOnClick && typeof activityId === "undefined") throw new Error("If you set hideOnClick === true, you must provide an activityId.")
    }, []);

    useEffect(() => {
        if (typeof isWarning !== 'undefined' && !isWarning && typeof icon === 'undefined') throw new Error('When isWarning === false, you must provide an icon')
    }, []);

    const _setColor = () => {
        if (iconColor) return iconColor
        if (isWarning) return theme.colors.warningLight
        if (typeof whichFootnoteType !== "undefined") {
            switch (whichFootnoteType) {
                case WHICH_FOOTNOTE_TYPE.date:
                    return theme.colors.black
                case WHICH_FOOTNOTE_TYPE.route:
                    return theme.colors.black
                case WHICH_FOOTNOTE_TYPE.warning:
                    return theme.colors.warningLight
                case WHICH_FOOTNOTE_TYPE.calculation:
                    return theme.colors.warningLight
                default:
                    whichFootnoteType satisfies never
            }
        }
        return theme.colors.black
    }

    const setIcon = () => {
        if (icon) return icon
        if (typeof whichFootnoteType !== "undefined") {
            switch (whichFootnoteType) {
                case WHICH_FOOTNOTE_TYPE.date:
                    return "calendar"
                case WHICH_FOOTNOTE_TYPE.route:
                    return "route"
                case WHICH_FOOTNOTE_TYPE.warning:
                    return "exclamationCircle"
                case WHICH_FOOTNOTE_TYPE.calculation:
                    return "squareRootVariable"
                default:
                    whichFootnoteType satisfies never
            }
        }
        return "exclamationCircle"
    }

    const _renderContent = () => {
        if (tooltip) return <Tooltip
            placement={"top"}
            title={tooltip}>
            {_renderIconAndDiv()}
        </Tooltip>

        return _renderIconAndDiv()
    }

    const _onClick = () => {
        if (typeof whereToDisplay === "undefined" || typeof activityId === "undefined") return

        switch (whereToDisplay) {
            case WhereToDisplayActivityString.journey:
                dispatch(setJourneyHideLoadBundleInformation({activityId, value: true}))
                break;
            case WhereToDisplayActivityString.travelComponents:
                dispatch(setTravelComponentsHideLoadBundleInformation({activityId, value: true}))
                break;
            case WhereToDisplayActivityString.pdf:
                break;
            case WhereToDisplayActivityString.dropdownJourney:
                break;
            default:
                whereToDisplay satisfies never
        }
    }

    const _renderIconAndDiv = () => <div style={ICON_MARGIN}>
        {hideOnClick ? <button onClick={_onClick}
                               className={"string-display-footnote-icon-button"}>{_renderIcon()}</button> : _renderIcon()}
    </div>

    const _renderIcon = () => <Icon
        color={_setColor()}
        size={"verySmall"}
        icon={setIcon()}/>

    return _renderContent()
}

export default StringDisplayFootnoteIcon



